import type {
  ChallengesAction,
  ChallengesReducer,
} from "../reducers/challenges";

type IdeaViewType = ChallengesReducer["ideaViewType"];

const challengesActions = {
  UPDATE_IDEA_FILTERS: "UPDATE_IDEA_FILTERS",
  SET_IDEA_VIEW_TYPE: "SET_IDEA_VIEW_TYPE",

  updateIdeaFilters(data: Partial<ChallengesReducer>): ChallengesAction {
    return { type: "UPDATE_IDEA_FILTERS", data };
  },
  setIdeaViewType(ideaViewType: IdeaViewType | string): ChallengesAction {
    return {
      type: "SET_IDEA_VIEW_TYPE",
      ideaViewType: ideaViewType as IdeaViewType,
    };
  },
};

export default challengesActions;
